import _extends from 'babel-runtime/helpers/extends';
import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  flex-wrap: wrap;\n  display: flex;\n  ', '\n'], ['\n  flex-wrap: wrap;\n  display: flex;\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n      pointer-events: none;\n      opacity: 0.4;\n    '], ['\n      pointer-events: none;\n      opacity: 0.4;\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 30px;\n  max-width: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  margin: 4px;\n  padding: 4px;\n  ', '\n'], ['\n  width: 30px;\n  max-width: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  margin: 4px;\n  padding: 4px;\n  ', '\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n          background: ', ';\n          color: white;\n          font-weight: 600;\n        '], ['\n          background: ', ';\n          color: white;\n          font-weight: 600;\n        ']),
    _templateObject5 = _taggedTemplateLiteral(['\n          cursor: pointer;\n          &:hover {\n            background: ', ';\n          }\n        '], ['\n          cursor: pointer;\n          &:hover {\n            background: ', ';\n          }\n        ']),
    _templateObject6 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  margin: 8px 0;\n  & > input[type=\'radio\'] {\n    margin-right: 8px;\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  margin: 8px 0;\n  & > input[type=\'radio\'] {\n    margin-right: 8px;\n  }\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  ', '\n'], ['\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  ', '\n']);

import React from 'react';
import styled, { css } from 'styled-components';
import EveryInput from './EveryInput';
import { styles, translations } from 'gipsy-misc';
import Select from '../../../../../Select';

//todo: make it smart (depend on "when")
var DEFAULT_DAY_OPTIONS = { day: 1, onSchedule: null, onOrdinal: null };
var DEFAULT_SCHEDULE_OPTIONS = { day: null, onSchedule: 'day', onOrdinal: 1 };

var DAYS = Array.from({ length: 28 }, function (x, i) {
  return i + 1;
});

var ORDINALS = [{ value: 1, label: translations.taskPanel.recurrency.first }, { value: 2, label: translations.taskPanel.recurrency.second }, { value: 3, label: translations.taskPanel.recurrency.third }, { value: -1, label: translations.taskPanel.recurrency.last }];

var SCHEDULES = [{ value: 'day', label: translations.general.day.singular }, { value: 'weekday', label: translations.taskPanel.recurrency.weekday }, { value: 'weekend-day', label: translations.taskPanel.recurrency.weekendDay }, { value: 'monday', label: translations.days.label.monday }, { value: 'tuesday', label: translations.days.label.tuesday }, { value: 'wednesday', label: translations.days.label.wednesday }, { value: 'thursday', label: translations.days.label.thursday }, { value: 'friday', label: translations.days.label.friday }, { value: 'saturday', label: translations.days.label.saturday }, { value: 'sunday', label: translations.days.label.sunday }];

var Days = styled.div(_templateObject, function (_ref) {
  var disabled = _ref.disabled;
  return disabled && css(_templateObject2);
});
var Day = styled.div(_templateObject3, function (_ref2) {
  var selected = _ref2.selected;
  return selected ? css(_templateObject4, styles.colors.buttonDarkColor) : css(_templateObject5, styles.colors.borderColor);
});

var RadioRow = styled.div(_templateObject6);

var ScheduleRow = styled.div(_templateObject7, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled && css(_templateObject2);
});

var onRecurrencyTypeChange = function onRecurrencyTypeChange(currentValue, onChange) {
  return function (e) {
    if (e.target.value === 'schedule') {
      onChange(_extends({}, currentValue, DEFAULT_SCHEDULE_OPTIONS));
    } else {
      onChange(_extends({}, currentValue, DEFAULT_DAY_OPTIONS));
    }
  };
};

var ScheduleSelector = function ScheduleSelector(_ref4) {
  var value = _ref4.value,
      _onChange = _ref4.onChange;
  var onSchedule = value.onSchedule,
      onOrdinal = value.onOrdinal;

  var ordinalOption = ORDINALS.find(function (x) {
    return x.value === onOrdinal;
  });
  var scheduleOption = SCHEDULES.find(function (x) {
    return x.value === onSchedule;
  });

  return React.createElement(
    ScheduleRow,
    { disabled: !onSchedule },
    React.createElement(
      'div',
      { style: { width: 150 } },
      React.createElement(Select, {
        options: ORDINALS,
        menuPlacement: 'top',
        value: ordinalOption,
        onChange: function onChange(o) {
          return _onChange(_extends({}, value, { onOrdinal: o.value }));
        }
      })
    ),
    React.createElement(
      'div',
      { style: { width: 150, marginLeft: 12 } },
      React.createElement(Select, {
        options: SCHEDULES,
        menuPlacement: 'top',
        value: scheduleOption,
        onChange: function onChange(o) {
          return _onChange(_extends({}, value, { onSchedule: o.value }));
        }
      })
    )
  );
};

var MonthlyInput = function MonthlyInput(_ref5) {
  var value = _ref5.value,
      _onChange2 = _ref5.onChange;
  var every = value.every,
      day = value.day,
      onSchedule = value.onSchedule;

  return React.createElement(
    'div',
    null,
    React.createElement(EveryInput, {
      value: every,
      onChange: function onChange(every) {
        return _onChange2({ every: every });
      },
      label: translations.taskPanel.recurrency.month
    }),
    React.createElement(
      RadioRow,
      null,
      React.createElement('input', {
        name: 'recurrencyType',
        type: 'radio',
        value: 'day',
        checked: !onSchedule,
        onChange: onRecurrencyTypeChange(value, _onChange2)
      }),
      translations.taskPanel.recurrency.each
    ),
    React.createElement(
      Days,
      { disabled: !!onSchedule },
      DAYS.map(function (i) {
        return React.createElement(
          Day,
          { key: i, selected: day === i, onClick: function onClick() {
              return day !== i && _onChange2(_extends({}, value, { day: i }));
            } },
          i
        );
      })
    ),
    React.createElement(
      RadioRow,
      null,
      React.createElement('input', {
        name: 'recurrencyType',
        type: 'radio',
        value: 'schedule',
        checked: !!onSchedule,
        onChange: onRecurrencyTypeChange(value, _onChange2)
      }),
      translations.taskPanel.recurrency.onThe
    ),
    React.createElement(ScheduleSelector, { value: value, onChange: _onChange2 })
  );
};

export default MonthlyInput;
//# sourceMappingURL=MonthlyInput.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/fields/When/RecurrencyDetails/components/MonthlyInput.js
// module id = 1102
// module chunks = 0